import { lazy, Suspense } from 'react';

// Lazy load the confetti animation component
const ConfettiAnimation = lazy(() =>
  import('./confetti-animation').then((module) => ({ default: module.ConfettiAnimation }))
);

interface LazyConfettiAnimationProps {
  isAnimating: boolean;
  onComplete: () => void;
}

export const LazyConfettiAnimation = ({ isAnimating, onComplete }: LazyConfettiAnimationProps) => {
  if (!isAnimating) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <ConfettiAnimation isAnimating={isAnimating} onComplete={onComplete} />
    </Suspense>
  );
};
